// Helpers to add DOM elements as Phaser GameObjects. Phaser's canvas text bitmap
// stays at 1× so retina screens upscale-blur it; HTML text is browser-native
// crisp. Used for every static label in the arcade UI.
import type Phaser from "phaser";

export function domText(
  scene: Phaser.Scene,
  x: number,
  y: number,
  text: string,
  className: string,
  depth = 30,
) {
  const el = document.createElement("div");
  el.className = `arc-text ${className}`;
  el.textContent = text;
  return scene.add.dom(x, y, el).setOrigin(0.5).setDepth(depth);
}

export function domEl(
  scene: Phaser.Scene,
  x: number,
  y: number,
  el: HTMLElement,
  depth = 30,
) {
  return scene.add.dom(x, y, el).setOrigin(0.5).setDepth(depth);
}

export function domClickable(
  scene: Phaser.Scene,
  x: number,
  y: number,
  text: string,
  className: string,
  onClick: () => void,
  depth = 30,
) {
  const el = document.createElement("div");
  el.className = `arc-text ${className}`;
  el.textContent = text;
  el.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    onClick();
  });
  return scene.add.dom(x, y, el).setOrigin(0.5).setDepth(depth);
}

export function starsHTML(earned: number, klass = "arc-stars"): HTMLElement {
  const el = document.createElement("div");
  el.className = klass;
  for (let i = 0; i < 3; i++) {
    const s = document.createElement("span");
    s.className = i < earned ? "arc-star-on on" : "arc-star-off off";
    s.textContent = "★";
    el.appendChild(s);
  }
  return el;
}
